export const DELETE_USER_SUCCESS = '@@user/DELETE_USER_SUCCESS';
